<template>
	<form @submit.prevent="search">
		<div class="card mt-4">
			<div class="card-body">
				<div class="row">
					<div class="col-md-10">
						<div class="row">
							<div class="form-group col-md-2">
								<label for>N° Solicitud:</label>
								<input v-model="filter.number" class="form-control" type="text" />
							</div>
							<div v-if="!isDispatcher && !isCourier && disable == false" class="form-group col-md-2">
								<label for>Estado:</label>
								<v-select v-model="stateModel" :options="status">
									<span slot="no-options">No se encontraron estados</span>
								</v-select>
							</div>
							<div v-if="isAdmin || (isDispatcher && disable == false)" class="form-group col-md-2">
								<label for>Objetivo:</label>
								<v-select v-model="targetModel" :options="targets">
									<span slot="no-options">No se encontraron solicitantes</span>
								</v-select>
							</div>
							<div v-if="isAdmin || isDispatcher" class="form-group col-md-2">
								<label for>Solicitante:</label>
								<v-select v-model="applicantModel" :options="applicants">
									<span slot="no-options">No se encontraron solicitantes</span>
								</v-select>
							</div>
							<div class="form-group col-md-2">
								<label for>Fecha de Envío desde:</label>
								<input id="required-dispatch-date-from" v-model="filter.fromDate" class="form-control"
									type="date" />
							</div>
							<div class="form-group col-md-2">
								<label for>Fecha de Envío hasta:</label>
								<input id="required-dispatch-date-to" v-model="filter.toDate" class="form-control"
									type="date" />
							</div>
							<div v-if="isDispatcher" class="form-group col-md-2">
								<b-form-checkbox v-model="filter.seeAll" style="padding-top: 30px;" class="mt-2"
									switch >
									Ver todo
								</b-form-checkbox>
							</div>
						</div>
					</div>
					<div class="col-md-2">
						<div class="row align-items-end">
							<div class="form-group col">
								<div class="mt-4 text-right">
									<button class="btn btn-dark ml-2 mt-2">
										<i class="fa fa-search mr-2"></i>Buscar
									</button>
									<button class="btn btn-dark ml-2 mt-2" type="button" @click="reset">
										<i class="fa fa-sync-alt mr-2"></i>Reset
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-header text-right" style="float: right">
				<button class="btn btn-success" title="Exportar Búsqueda en Excel" type="button" @click="exportXls">
					<i class="fas fa-file-excel mr-2"></i> Exportar
				</button>
			</div>
		</div>
	</form>
</template>

<script>
export default {
	data() {
		return {
			isDispatcher: this.$store.getters.isDispatcher,
			isCourier: this.$store.getters.isCourier,
			isAdmin: this.$store.getters.isAdmin,
			label: "No",
			status: [
				"Creado",
				"Enviado",
				"Valido para Despacho",
				"En validación de Enología",
				"Despachado Bodega",
				"Calidad",
				"Despachado",
				"Confirmado",
			],
			stateModel: "",
			progressiveDispatch: false,
			filter: {},
			applicantModel: {
				code: null,
				label: null,
			},
			targetModel: {
				code: null,
				label: null,
			},
		};
	},
	props: ["links", "applicants", "targets", "disable"],
	watch: {
		number: function () {
			this.filter.number = this.number;
		},
		to: function () {
			this.filter.toDate = this.toDate;
		},
		from: function () {
			this.filter.fromDate = this.fromDate;
		},
		state: function () {
			this.filter.state = this.state;
		},
		applicant: function () {
			this.filter.applicant =
				this.applicant != null ? this.applicant.code : null;
		},
		seeAll: function () {
			this.filter.seeAll != null ?  this.seeAll : false;
		},
		target: function () {
			this.filter.target = this.target != null ? this.target.code : null;
		},
	},
	created() { 
		if (this.$route.query.seeAll)
			this.filter.seeAll = this.$route.query.seeAll
	},
	methods: {
		index() {
			this.$emit("index");
		},
		search() {
			this.$router.push({
				path: this.$route.path,
				query: this.filter,
			});
		},
		reset() {
			if (this.$route.fullPath != "/") {
				this.filter = {};
				this.stateModel = "";
				this.search();
			}
		},
		exportXls() {
			this.$emit("exportXls");
		},
		exportPdf() {
			this.$emit("exportPdf");
		},
	},
	computed: {
		number() {
			return this.$route.query.number ? this.$route.query.number : "";
		},
		toDate() {
			return this.$route.query.toDate ? this.$route.query.toDate : "";
		},
		fromDate() {
			return this.$route.query.fromDate ? this.$route.query.fromDate : "";
		},
		state() {
			return this.stateModel != "" ? this.stateModel : "";
		},
		applicant() {
			return this.applicantModel != null ? this.applicantModel : null;
		},
		target() {
			return this.targetModel != null ? this.targetModel : null;
		},
		seeAll() {
			return this.$route.query.seeAll ? this.$route.query.seeAll : null;
		}
	},
};
</script>
